import { useTranslation } from "react-i18next";
import UploadFileForm from "../../../../../components/input/input-register/UploadFileForm";

const BusinessLicense = ({
    containerClass,
    formRefs,
    errorsProfileData,
    businessLicenseFile,
    handleButtonChooseFile,
    handleFileSelect,
    handleRemoveBusinessLicense,
    selectedFile,
    preview
}) => {
    const { t } = useTranslation();

    return (
        <div className={containerClass}>
            <p className="tw:!text-[18px] tw:!font-[600] tw:!text-[#282828] tw:!mb-2">
                {t("businessRegister.businessLicense.title")} <span className="tw:text-red-600">*</span>
            </p>
            <div className="tw:!flex tw:!flex-wrap">
                <div className="tw:!flex-1">
                    <UploadFileForm
                        file={businessLicenseFile}
                        innerRef={formRefs.businessLicenseFileRef}
                        desc={t("businessRegister.businessLicense.form.desc")}
                        buttonLabel={t("businessRegister.businessLicense.form.button")}
                        isInvalid={errorsProfileData.license}
                        invalidMessage={t(errorsProfileData.license)}
                        chooseFileHandler={handleButtonChooseFile}
                        onChange={handleFileSelect}
                        onRemove={handleRemoveBusinessLicense}
                        accept={"image/jpeg,.pdf"}
                        selectedFile={selectedFile}
                        preview={preview}
                    />
                </div>
            </div>
        </div>
    );
};

export default BusinessLicense;
